var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./storePage/petInfoComponent'));
    processInclude(require('./storePage/recipePage'));
});
